// extracted by mini-css-extract-plugin
export default {"wrapper":"AttachButton_wrapper__PqVSs","attachButton":"AttachButton_attachButton__WmugF","ring":"AttachButton_ring__IlHqh"};